import React from 'react';
import { Card, Row, Col,  } from 'react-bootstrap';
import "./CardHelp.css";
import useIsMobile from '../../../../Hooks/useIsMobile';

const CardHelp = ({icono__card__help,titulo__card__help,texto__card__help,class__text__card__help,class__link__card__help,}) => {
    const isMobile = useIsMobile()

    return (      
        <Card className='card__help' style={{border: 'none'}}>
            <Row className='m-0 align-items-center'>
                <Col className='col-12 col-lg-12 order-1 order-lg-1 text-center p-0'>
                    { 
                        isMobile&&(
                        <p className='titulo__card__help mb-4 mt-3 text-black'>
                        {titulo__card__help}
                        </p>)
                    }
                    <img className='icon__card__help' src={icono__card__help} width={50} height={50} alt="icono ayuda"></img>
                </Col>
                <Col className='col-12 col-lg-12 order-2 order-lg-2 p-0'>
                    { 
                        !isMobile&&(
                        <p className='titulo__card__help'>
                        {titulo__card__help}
                        </p>)
                    }
                    <p className={class__text__card__help+' fontOpenSans banistmo-black'}>
                        {texto__card__help}
                    </p>
                    <div className={class__link__card__help}>
                        <a className='link__anchor__gray' href='/ayuda-al-cliente'>Visita nuestras preguntas frecuentes</a>                                        
                    </div>
                </Col>                
            </Row>
        </Card>
    );
};

export default CardHelp;